import { useState, useCallback } from "react";
import PropTypes from "prop-types";

import { usePreferences } from "./library";
import {
    A11Y_SPORTS_LIST_TEXT,
    SPORTS_LISTS,
    SHOW_SPORTS,
    SECTION_TITLES,
} from "./constants";

import IconChevron from "../Icon/IconChevron";
import If from "../If/component";
import SportsGrid from "./SportsGrid";
import SaveButton from "./SaveButton";

export default function OlympicSportsList(props) {
    const { getPreference, hasChanges, update, save } = usePreferences();
    const [isExpanded, setExpanded] = useState(!props.allowExpand);
    const onClose = props.onClose || (() => {});
    const onSave = useCallback(() => {
        save();
        onClose();
    }, [props.onClose, save]);

    return (
        <div className="olympicSportsList" data-testid="olympicSportsList">
            <If value={!props.allowExpand}>
                <span className="a11y" aria-live="polite">
                    {A11Y_SPORTS_LIST_TEXT}
                </span>
            </If>
            <SportsGrid
                sports={SPORTS_LISTS.TRENDING_SPORTS}
                title={SECTION_TITLES.MOST_POPULAR}
                classes={["trendingSports"]}
                showIcons
                onChange={update}
                getPreference={getPreference}
            />
            <If value={props.allowExpand}>
                <div className="showSportsContainer">
                    <button
                        onClick={() => setExpanded((x) => !x)}
                        className={`showAllSports ${isExpanded ? "open" : ""}`}
                        aria-expanded={isExpanded}
                        data-testid="showAllSportsButton"
                    >
                        {isExpanded
                            ? SHOW_SPORTS.FEWER_SPORTS
                            : SHOW_SPORTS.ALL}
                        <IconChevron />
                    </button>
                </div>
            </If>
            <If value={isExpanded}>
                <SportsGrid
                    sports={SPORTS_LISTS.ALL_SPORTS}
                    title={SECTION_TITLES.ALL}
                    classes={["allSports"]}
                    onChange={update}
                    getPreference={getPreference}
                />
            </If>
            <SaveButton onSave={onSave} disabled={!hasChanges} />
        </div>
    );
}

OlympicSportsList.propTypes = {
    allowExpand: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
